/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, CircularProgress, Backdrop } from '@mui/material';
import { convertUnitValues_flow } from '../../shared/conversion-helper/unitConversion';
import { getFlowSheet } from '../../shared/api/url-helper';
import { decrypt_data } from '../../shared/utils';
import { defaultModalOptions } from '../../shared/constantVariable';
import { ROMOpen, ROMDownload } from '../../shared/assets/images';

const RomCard = (props) => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [, setModalOption] = useState(defaultModalOptions);
  const navigate = useNavigate();
  const { machineModelName, ApproxPermeateflow, FactSheet1, FactSheet2, FactSheet3, unit, item, translateObject } = props;
  let covertedPermeateflow = Number.parseFloat(ApproxPermeateflow).toFixed(2);
  if (unit.flow !== 'gpm') {
    covertedPermeateflow = convertUnitValues_flow(ApproxPermeateflow, 'gpm', unit.flow);
    covertedPermeateflow = Number.parseFloat(covertedPermeateflow).toFixed(2);
  }
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions),
      type
    });
  };
  const openROMFile = () => {
    const unit_set_dict = {
      'type': unit.type,
      'Volume Flow': unit.flow,
      'Pressure': unit.pressure,
      'Temperature': unit.temp,
      'Liquid Volume': unit.volume,
      'Flux': unit.flux,
      'Power': unit.power
    };
    const recommender_input_dict = {
      unit_set_dict,
      ro_machine: item.ROMachineModel
    };
    Promise.all([getFlowSheet(recommender_input_dict)]).then((res) => {
      // Decrypt the data from the response
      const decData = decrypt_data(res[0].data);
      // Set the loaded file state with the file name from the decrypted data
      if (decData.file_name && decData.file_name !== 'Invalid Inputs!!!!') {
        navigate(`/main?romachine/${decData.file_name}`);
      } else {
        openModelPopUp('Invalid Inputs!!!!', 'Error', 'error');
      }
      // Set loading state to false
      setFetchLoading(false);
    }).catch(() => {
      // If there's an error, set loading state to false and open a modal popup with an error message
      setFetchLoading(false);
      openModelPopUp('Failed to fetch Flowsheet Selection record', 'Error', 'error');
    });
    // send flow rate data in m/s.
  };

  return (
    <div className='RomCard'>
      {fetchLoading && <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        style={{
          background: '#d9dbde5c',
        }}
        open={fetchLoading}>
        <CircularProgress style={{ color: '#4b93f4' }} size={40} disableShrink />
      </Backdrop>}
      <div className='cardHeader'> {machineModelName}</div>
      <div className='pfr'> {translateObject('Permeate Flow Rate')}
        <span className='pfrValue'>{covertedPermeateflow}</span> ({unit.flow})
      </div>
      <Button className="Secondary-Default_button" variant="contained"
        onClick={openROMFile} endIcon={<img src={ROMOpen} alt="ROMOpen" />}>{translateObject('Open')}</Button>
      {FactSheet1 && <Button className="Primary_Default_Button" variant="contained" onClick={() => window.open(FactSheet1, '_blank', 'noreferrer')} endIcon={<img src={ROMDownload} alt="ROMDownload" />}>{translateObject('FactSheet')}-1</Button>}
      {FactSheet2 && <Button className="Primary_Default_Button" variant="contained" onClick={() => window.open(FactSheet2, '_blank', 'noreferrer')} endIcon={<img src={ROMDownload} alt="ROMDownload" />}>{translateObject('FactSheet')}-2</Button>}
      {FactSheet3 && <Button className="Primary_Default_Button" variant="contained" onClick={() => window.open(FactSheet3, '_blank', 'noreferrer')} endIcon={<img src={ROMDownload} alt="ROMDownload" />}>{translateObject('FactSheet')}-3</Button>}
    </div >
  );
};

export default RomCard;